import { onMounted, watch, WatchSource, WatchCallback, WatchOptions, WatchStopHandle, onBeforeUnmount } from 'vue'

/**
 * mounted 之后再 watch，beforeUnmount 移除 watch
 * @param source
 * @param cb
 * @param options
 */
export const safeWatch = <T, Immediate extends Readonly<boolean> = false>(
  source: WatchSource<T>,
  cb: WatchCallback<T, Immediate extends true ? T | undefined : T>,
  options?: WatchOptions<Immediate>
) => {
  let watchStopHandle: WatchStopHandle
  onMounted(() => {
    watchStopHandle = watch(source, cb, options)
  })
  onBeforeUnmount(() => {
    watchStopHandle()
  })
}
